import { Box, Icon, Loader, Text, useHover } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { Pressable } from 'react-native';
import usePurchaseShopItem from '../../hooks/usePurchaseShopItem';
import { ShopDiscountCtaProps } from './ShopDiscountCta.types';
import { DISABLED_BUTTON_OPACITY } from '@bonanza-social/moonlight/lib/common/Button/Button.content';
import { formatNumber } from '@bonanza-social/toolkit/utils';

function ShopDiscountCta({ slot, closeBottomSheet }: ShopDiscountCtaProps) {
  const { isHovered, ...hoverTriggers } = useHover();

  const { purchase, isPurchasing } = usePurchaseShopItem({
    id: slot.slotId,
    type: slot.item.type,
    isSlotItem: true,
    closeBottomSheet,
  });

  const disabled = Boolean(isPurchasing || slot.cooldownEnd);

  return (
    <Pressable
      onPress={purchase}
      accessibilityRole="button"
      style={{ width: '100%' }}
      disabled={disabled}
      {...(disabled ? undefined : hoverTriggers)}
    >
      <Box
        opacity={disabled ? DISABLED_BUTTON_OPACITY : 1}
        alignItems="center"
        justifyContent="center"
        borderRadius="radius-200"
        height={40}
        variant="gradient"
        gradient={isHovered ? 'accentBackgroundHover' : 'accentBackground'}
        paddingHorizontal="space-300"
        width="100%"
        flexDirection="row"
        gap="space-100"
      >
        <Icon
          name="bonanzaCoin"
          width={20}
          height={20}
          color="accentSurfacePrimary"
        />
        <Box flexDirection="row" gap="space-100">
          <Text variant="button-small" color="accentSurfacePrimary">
            {formatNumber(slot.item.discountedPrice)}
          </Text>
          <Text variant="button-small" color="accentSurfaceDisabled" crossedOut>
            {formatNumber(slot.item.price)}
          </Text>
        </Box>
        {isPurchasing ? <Loader position="absolute" /> : null}
      </Box>
    </Pressable>
  );
}

export default memo(ShopDiscountCta);
